import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Icon } from "@bookips/sds";
import { AnimatePresence, motion } from "framer-motion";
import { RadiusBoxStyle } from ".";
// 주문 상품과 주문자 컴포넌트에서 사용 될..
export const DropDownBox = (param)=>{
    let { headTitle , bodyElement , headRightElement , dropDownMode , handleDropDown , openDropDown  } = param;
    return /*#__PURE__*/ _jsxs(RadiusBoxStyle, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                role: "button",
                className: cn("flex items-center justify-between w-full text-strong cursor-pointer"),
                onClick: handleDropDown,
                children: [
                    headTitle,
                    /*#__PURE__*/ _jsxs("p", {
                        className: "flex items-center gap-2",
                        children: [
                            headRightElement && headRightElement,
                            dropDownMode && /*#__PURE__*/ _jsx("span", {
                                className: "w-6 h-6 p-[3px] block transition-transform duration-200 ".concat(openDropDown ? "" : "rotate-180"),
                                children: /*#__PURE__*/ _jsx(Icon.ArrowDown_2px, {})
                            })
                        ]
                    })
                ]
            }),
            dropDownMode ? /*#__PURE__*/ _jsx(AnimatePresence, {
                initial: false,
                children: !openDropDown && /*#__PURE__*/ _jsx(motion.div, {
                    initial: {
                        height: 0,
                        opacity: 0
                    },
                    animate: {
                        height: "auto",
                        opacity: 1
                    },
                    exit: {
                        height: 0,
                        opacity: 0
                    },
                    transition: {
                        duration: 0.4,
                        ease: "easeInOut"
                    },
                    style: {
                        overflow: "hidden"
                    },
                    children: bodyElement
                }, "checkout-list")
            }) : bodyElement
        ]
    });
};
